// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__H8jb5","writeIcon":"Icon_writeIcon__jqKCk"};